function zoomInImg(zoomUrl) {
        
        $('#photoSwipeBox').hide();
        $("#photoSwipeBox").data('royalSlider').prev();
        $('#photoZoomBox img').attr('src', zoomUrl);
        $('#photoZoomBoxParent').show(); 
        $('#photoZoomBox').panzoom({
            startTransform: 'scale(1.1)',
            minScale: 1.0,
            maxScale: 5.0,
            increment: 0.5
        }).panzoom('zoom', true);
          
        
        $('#photoZoomBox').parent().on('mousewheel.focal', function( e ) {
            e.preventDefault();
            var delta = e.delta || e.originalEvent.wheelDelta;
            var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
            $('#photoZoomBox').panzoom('zoom', zoomOut, {
                increment: 0.1,
                animate: false,
                focal: e
            });
        });   
      
    }

    function zoomOutImg() {
        $('#photoZoomBox').panzoom("reset", true);      
        setTimeout(function () {
            $('#photoZoomBoxParent').hide();
            $('#photoZoomBox img').attr('src', '');
            $('#photoSwipeBox').show();
        }, 300);
        
    }


    jQuery(document).ready(function($) {
        $("#photoSwipeBox").royalSlider({
            keyboardNavEnabled: false,
            loop: true,
            //navigateByClick: false,
            autoScaleSliderHeight: 400,
            transitionSpeed: 1500,
            autoScaleSlider: false,
            autoPlay: {
                enabled: false
            }
        });
        $('.bannerBox').show();
        if ($('#img1').length == 0) {
            $('.rsNav').hide();
        }


    });